import { Grid } from '@chakra-ui/react';
import { ContractSearchResponseDTO } from 'models';
import formatter from 'utils/formatter';
import { DetailItem } from './DetailItem';

interface ViewFormProps {
  contract: ContractSearchResponseDTO;
}

export const ViewComplementaryDataFormReadOnly = ({ contract }: ViewFormProps) => {
  return (
    <Grid templateColumns={{ base: '1fr', md: 'repeat(3, 1fr)' }} gap={4}>
        <DetailItem label="Comentários" value={contract.comentarios} />
        <DetailItem label="Número Aditivo" value={contract.numeroAditivo} />
        <DetailItem label="Data Aditivo" value={formatter.data(contract.dataAditivo)} />
    </Grid>
  );
};